/* global angular, Chance, jQuery */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('tabSelector', ['Input', 'HistoricContext', 'MixpanelAdvancedSearch',
    function (Input, HistoricContext, MixpanelAdvancedSearch) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var key = attrs.key;

                var isSelected = function () {
                    return scope.selectedTab === key;
                };

                Input.addAccessibleClickHandler(element, function () {
                    scope.$apply(function () {
                        scope.selectedTab = key;
                    });
                });

                scope.$watch('selectedTab', function (newValue, oldValue) {
                    if (isSelected()) {
                        element.addClass('active');
                        element.removeClass('inactive');

                        var filterName = HistoricContext.getValue('search_filter_name_context');
                        var filterType = HistoricContext.getValue('search_filter_type_context');
                        var tab = oldValue.charAt(0).toUpperCase() + oldValue.substring(1, oldValue.length) + 's';
                        if (tab === 'Observations' || tab === 'Trends') {
                            MixpanelAdvancedSearch.advancedSearch(filterName, filterType, tab);
                            MixpanelAdvancedSearch.clearSearchFilter();
                        }
                    } else {
                        element.addClass('inactive');
                        element.removeClass('active');
                    }
                    scope.$broadcast('tabChanged', scope.selectedTab);
                });
            }
        };
    }]);

ngModule.directive('visibilityTracker', ['$rootScope',
    function ($rootScope) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var target = attrs.visibilityTracker;

                scope.targetVisible = true;

                $rootScope.$on('element-visibility', function (event, name, visible) {
                    if (name === target) {
                        scope.targetVisible = visible;
                    }
                });
            }
        };
    }]);

ngModule.directive('requiresFlash', ['$window',
    function ($window) {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: null,
            link: function (scope, element, attrs) {
                var flashAvailable = false;

                var version = attrs.requiresFlash;
                if (!version) {
                    version = '1';
                }
                if ($window.swfobject.hasFlashPlayerVersion(version)) {
                    flashAvailable = true;
                }

                scope.flashAvailable = function() {
                    return flashAvailable;
                };
            }
        };
    }]);

ngModule.directive('clickAndPress',
    function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var fn = attrs.clickAndPress;
                element.bind('click', function() {
                    scope.$apply(fn);
                });

                element.bind('keypress', function (event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        scope.$apply(fn);
                    }
                });
            }
        };
    });

ngModule.filter('slice', function () {
    return function (arr, start, end) {
        return (arr || []).slice(start, end);
    };
});

var colorIndex = 0; // Use as an index for the different default background colors available
var numberOfColors = 9; // Correspond to the number of default-background css class defined

/* This directive is used to resolve a bug in IE with the background-image
   IE needs to have quote around the url while chrome and other browsers do not
   It also use the default Mintel colors as fallback if we don't have any images. */

// This is in a huge need of refactoring, super quick and dirty !
ngModule.directive('addBackgroundImage', ['BrowserDetector',
    function (BrowserDetector) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                // a seed used for the pseudorandom generation, if -1 then just go completely random
                var color = attrs.color;
                if (!color) {
                    var givenImageUrl = attrs.imageUrl;
                    var imageUrl = '';
                    if(givenImageUrl) {
                        imageUrl = givenImageUrl;
                    }
                    else {
                        // This is used on the HVT page as they don't item
                        var item = attrs.addBackgroundImage ? scope.$eval(attrs.addBackgroundImage) : scope.item;

                        // This is on the homepage to select the homepage version of the images
                        imageUrl = attrs.type === 'homepage' ? item.homepage_image_url : item.image_url;
                    }
                    var browser = BrowserDetector.getBrowserInfo();
                    var isIe = browser.name === 'MSIE';
                    var isOldIe = isIe && browser.version <= 8;

                    // We always apply the background when we are on Internet Explore 8 and earlier
                    if (imageUrl && !isOldIe) {
                        if (isIe){
                            imageUrl = 'url("' + imageUrl + '")';
                        }
                        else {
                            imageUrl = 'url(' + imageUrl + ')';
                        }
                        element.css('background-image', imageUrl);
                    }
                    else {
                        element.addClass('default-background-' + colorIndex);
                        colorIndex = ++colorIndex % numberOfColors;
                    }
                }
                else {
                    // javascript doesn't support seeded random natively ;_;
                    var chance = new Chance(color);
                    element.addClass('default-background-' + chance.integer({min:0, max:numberOfColors}));
                }
            }
        };
    }]);

/* TODO These two directives are doing too much and should be refactored. */
ngModule.directive('fixedBar', ['BrowserDetector', '$timeout',
    function (BrowserDetector, $timeout) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var setFixed = function () {
                    element.attr('data-initial-top-offset', initialOffset);
                    element.addClass('fixed');
                    element.attr('data-fixed', 'fixed'); /* IE8 doesnt support not pseudo-class */
                    if($(document).scrollTop() < offset) {
                        element.removeClass('fixed');
                        element.attr('data-fixed', 'unfixed');
                        if (attrs.offsetDependency !== undefined) {
                            element.css('top', offset + 'px');
                        }
                    }
                    else {
                        element.css('top', '');  /* Remove any custom top css. */
                    }
                };
                if(!(BrowserDetector.getBrowserInfo().name === 'Safari' &&
                   (/iPad|iPhone|iPod/.test(navigator.platform)))) {
                    /* Use to have 2 fixedBar besides each other. Ex: dropdown */
                    var initialOffset = element.offset().top;
                    var fixedElementSelector = '.fixed-row';
                    if (attrs.fixedBar){
                        fixedElementSelector += attrs.fixedBar;
                    }
                    var offset = $(fixedElementSelector).offset().top;
                    if (attrs.offsetDependency !== undefined) {
                        offset = $(attrs.offsetDependency).attr('data-initial-top-offset');
                    }
                    $(window).scroll(setFixed);
                    $timeout(setFixed);
                }
            }
        };
}]);

ngModule.directive('stackingFixedBar', ['BrowserDetector', '$timeout',
    function (BrowserDetector, $timeout) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var setFixed = function () {
                    element.attr('data-initial-top-offset', initialOffset);
                    element.addClass('fixed');
                    element.attr('data-fixed', 'fixed'); /* IE8 doesnt support not pseudo-class */
                    if($(document).scrollTop() < offset) {
                        element.removeClass('fixed');
                        element.attr('data-fixed', 'unfixed');
                    }
                    else {
                        element.css('top', initialOffset + 'px');
                    }
                };
                if(!(BrowserDetector.getBrowserInfo().name === 'Safari' &&
                   (/iPad|iPhone|iPod/.test(navigator.platform)))) {
                    /* Use to have 2 fixedBar besides each other. Ex: dropdown */
                    var parentFixedBar = attrs.stackingFixedBar;
                    var offset = $(parentFixedBar).offset().top;
                    var initialOffset = offset + $(parentFixedBar).height();
                    element.css('top', initialOffset + 'px');
                    $(window).scroll(setFixed);
                    $timeout(setFixed);
                }
            }
        };
}]);

ngModule.directive('stopEvent',
    function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                /* Events coming from a target having the following class will be allowed.*/
                var allowedClasses = attrs.allowEvtFromClass;
                if (allowedClasses) {
                    var allowedClasses = attrs.allowEvtFromClass.trim().split(',');
                }
                scope.stopPropagationAndDefault = function(evt) {
                    var stop = true;
                    if (allowedClasses) {
                        allowedClasses.forEach(function(allowedClass) {
                            if (evt.target.className.indexOf(allowedClass) !== -1) {
                                stop = false;
                            }
                        });
                    }
                    if (stop) {
                        if (evt.preventDefault) {
                            evt.preventDefault();
                        }
                        else {  /* Some are still with IE8... */
                            evt.returnValue = false;
                        }
                        evt.stopPropagation();
                    }
                };
            }
        };
    });

ngModule.directive('hideTopSearch',
    function () {
        return {
            restrict: 'A',
            scope: true,
            link: function () {
                $('.top_search').css('display', 'none');
            }
        };
    });

ngModule.directive('elementLoadEvent', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element) {
            element.bind('load' , function(){
                scope.$emit('elementLoaded');
            });
        }
    };
});

ngModule.directive('toggleExpandCollapseBtn', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function(scope, element){
            var toggleExpand = function() {
                var source = element.parent();
                if(!source.hasClass('empty')) {
                    if(source.hasClass('collapsed')) {
                        var target = element.siblings('.panel-collapse');
                        target.css('overflow', 'visible');

                        source.removeClass('collapsed');
                        source.addClass('expanded');

                        if (element.hasClass('toggle-icon')) {
                            element.removeClass('PD-plus');
                            element.addClass('PD-minus');
                        }
                        else {
                            var icon_target = element.siblings('.toggle-icon');
                            icon_target.removeClass('PD-plus');
                            icon_target.addClass('PD-minus');
                        }
                    }
                    else if(source.hasClass('expanded')) {
                        var target = element.siblings('.panel-collapse');
                        target.css('overflow', 'hidden');

                        source.removeClass('expanded');
                        source.addClass('collapsed');

                        if (element.hasClass('toggle-icon')) {
                            element.removeClass('PD-minus');
                            element.addClass('PD-plus');
                        }
                        else {
                            var icon_target = element.siblings('.toggle-icon');
                            icon_target.removeClass('PD-minus');
                            icon_target.addClass('PD-plus');
                        }
                    }
                }
            };
            element.bind('click', toggleExpand);
            element.bind('keypress', function (event) {
                if (event.which === 13 || event.keyCode === 13) {
                    event.preventDefault();
                    toggleExpand();
                }
            });
        }
    };
});

// Used to fix a problem with using ng-html-bind on the statistics widget text in ie8
ngModule.filter('unsafe', ['$sce',
function($sce) {
    return function(val) {
        return $sce.trustAsHtml(val);
    };
}]);

ngModule.directive('decodeHtml', ['BrowserDetector', function (BrowserDetector) {
    return {
        restrict: 'A',
        link: function(scope, element){
            var browser = BrowserDetector.getBrowserInfo();
            var isIe = browser.name === 'MSIE';
            var isIe8 = isIe && browser.version === '8';
            scope.$watch(
                function() {
                    return element;
                },
                function (value) {
                    //  AngularJs gives us a jQuery set but we need the dom element itself
                    if (isIe8) {
                        if (value.length === 1 && value[0].innerText !== '') {
                            element[0].innerText = $('<div/>').html(value[0].innerText).text();
                        }
                    }
                    else {
                        if (value.length === 1 && value[0].textContent !== '') {
                            element[0].textContent = $('<div/>').html(value[0].textContent).text();
                        }
                    }
                }
            );
        }
    };
}]);

// Used to capitalise the first letter of a given string
ngModule.filter('capitalise', function() {
    return function(s) {
        return angular.isString(s) && s.length > 0 ?
            s.charAt(0).toUpperCase() + s.slice(1) : s;
    };
});

ngModule.directive('currentUrl', function() {
    return {
        restrict: 'A',
        scope: true,
        link: function(scope){
            scope.getCurrentUrl = function() {
                return location.href;
            };
        }
    };
});


